import { useEffect, useState } from 'react'

import { useActivityAccess, useQueryList, useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { APIErrorHandler } from '@percent/admin-dashboard/common/library/APIErrorHandler'
import { EligibilityDetailsView } from './EligibilityDetailsView/EligibilityDetailsView'
import { Organisation } from '@percent/admin-dashboard/api/types'

export function EligibilityDetailsContainer() {
  const { id } = useRequiredParams()

  const { eligibilityService, adminService } = useServices()
  const [organisation, setOrganisation] = useState<Organisation | null>(null)
  const [orgLoader, setOrgLoader] = useState(true)
  const [orgError, setOrgError] = useState('')

  const { canRead: canReadActivity } = useActivityAccess()

  const [
    { isLoading: isActivityEventsLoading, errorMessageOrNull: activityEventsErrorMessage, dataOrNull: activityEvents },
    { query: queryActivityEvents }
  ] = useQueryList(eligibilityService.getActivityEvents, { organisationId: id }, false)

  useEffect(() => {
    if (canReadActivity) {
      queryActivityEvents({ organisationId: id })
    }
  }, [canReadActivity, id, queryActivityEvents])

  const getData = async (orgId: string) => {
    setOrgLoader(true)
    try {
      const {
        data: { data: organisationData }
      } = await adminService.getOrganisation({ id: orgId })

      setOrganisation(organisationData)
      setOrgLoader(false)
    } catch (err) {
      setOrgError(APIErrorHandler(err?.response?.data?.error))
      setOrgLoader(false)
    }
  }

  useEffect(() => {
    if (id) {
      getData(id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <EligibilityDetailsView
      errorMessage={orgError || activityEventsErrorMessage || ''}
      isLoading={orgLoader || isActivityEventsLoading}
      organisation={organisation}
      activityEvent={activityEvents?.[0] ?? null}
    />
  )
}
